import {
  Directive,
  ElementRef,
  HostListener,
  Self,
} from '@angular/core';
import { NgControl } from '@angular/forms';
import { NotificationService } from '../notification.service';
import { CurrencyFormatterService } from 'src/app/shared/services/currency-formatter.service';

@Directive({
  selector: '[appCurrency]',
})
export class CurrencyDirective {
  // Allow decimal numbers and negative values
  private regex: RegExp = new RegExp(/^\d*\.?\d{0,2}$/g);

  // Allow key codes for special events. Reflect :
  // Backspace, tab, end, home
  private specialKeys: Array<string> = [
    'Backspace',
    'Tab',
    'End',
    'Home',
    '-',
    'ArrowLeft',
    'ArrowRight',
    'Del',
    'Delete',
  ];

  constructor(
    @Self() private ngControl: NgControl,
    private elementRef: ElementRef,
    private notification: NotificationService,
    private currencyFormatter: CurrencyFormatterService,
  ) {}

  private get symbol(): string {
    return this.currencyFormatter.getCurrencySymbol();
  }

  @HostListener('keydown', ['$event']) onKeyDown(event: KeyboardEvent) {
    // Allow Backspace, tab, end, and home keys
    if (this.specialKeys.indexOf(event.key) !== -1) return;

    let current: string = this.elementRef.nativeElement.value;
    current = current.slice(1).replace(/,/g, '');

    const next: string = current.concat(event.key);
    if (next && !String(next).match(this.regex)) {
      event.preventDefault();
    }
  }

  @HostListener('blur', ['$event']) onBlur(event: FocusEvent) {
    const value = this.ngControl.value
      ? this.ngControl.value.replace(/[^0-9\.]/g, '').trim()
      : null;
    if ((value && isNaN(Number(value))) || (!value && !isNaN(Number(value)))) {
      this.ngControl.reset(null);
    }
  }

  @HostListener('keyup', ['$event']) onKeyUp(event: KeyboardEvent) {
    const value = this.ngControl.value;
    this.elementRef.nativeElement.value = this.formatCurrency(value);
  }

  formatCurrency(amount) {
    return amount
      ? `${this.symbol}${amount
          .replace(/[^0-9\.]/g, '')
          .replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`
      : null;
  }
}
